import React from "react";
import { Route, Routes } from "react-router-dom";
import Complaints from "./Complaints";
import Overview from "./Overview";
import ProcedureHistory from "./ProcedureHistory";
import LiveFeed from "./LiveFeed";

export default function Locations(props) {
  return (
    <div className="inherit-parent-height inherit-parent-width">
      <Routes>
        <Route
          path="/overview/*"
          element={
            <Overview
              getLocationNextPage={props.getLocationNextPage}
              getLocationPage={props.getLocationPage}
              getLocationPreviousPage={props.getLocationPreviousPage}
              getLocationsSummary={props.getLocationsSummary}
              locationsLoading={props.locationsLoading}
              navigate={props.navigate}
            />
          }
        />
        {props.claims?.complaints?.read?.all ? (
          <Route
            path="/complaints/*"
            element={
              <Complaints
                complaintsLoading={props.complaintsLoading}
                getComplaintsNextPage={props.getComplaintsNextPage}
                getComplaintsPreviousPage={props.getComplaintsPreviousPage}
                getComplaintsSummary={props.getComplaintsSummary}
                importPenaltyFile={props.importPenaltyFile}
                navigate={props.navigate}
                claims={props.claims}
              />
            }
          />
        ) : (
          <></>
        )}
        {props.claims?.procedureHistory?.read ? (
          <Route
            path="/procedureHistory/*"
            element={
              <ProcedureHistory
                getHistorySummary={props.getHistorySummary}
                getProcedureHistoryNextPage={props.getProcedureHistoryNextPage}
                getProcedureHistoryPreviousPage={
                  props.getProcedureHistoryPreviousPage
                }
                navigate={props.navigate}
                procedureHistoryLoading={props.procedureHistoryLoading}
              />
            }
          />
        ) : (
          <></>
        )}
        {props.claims?.surveillance?.read ? (
          <Route
            path="/liveFeed/*"
            element={
              <LiveFeed
                navigate={props.navigate}
              />
            }
          />
        ) : (
          <></>
        )}
      </Routes>
    </div>
  );
}
